import { Badge, BlockStack, Button, ButtonGroup, Icon, InlineStack, Link, Pagination, Tag, Text, TextField, Tooltip } from '@shopify/polaris';
import { Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { DI, DIProps } from '../../../Core';
import { AmazonIcon, ShopifyIcon } from '../../../Asests/svgIcon/icon';
import { ExternalSmallMinor } from '@shopify/polaris-icons';
import { formatDate } from '../Overview/Utils/HelperFunc';
import { getAmazonOrderUrl, getShopifyShopUrl } from './Utils/Helper';
import { getStatusBadge } from '../StaffUserManagement/helper';
import { useDebounce } from '../useDebounce';
import { rows as skeletonRow } from './Utils/skeleton/FullfillmentSkeleton';

const NewArchievedOrderTable = (props: DIProps) => {
    const { t } = useTranslation();
    const [rowsData, setrows] = useState([])


    const getShopifyBadgeColor = (status: string) => {
        switch (status) {
            case 'Created':
                return 'attention';
            case 'Shipped':
                return 'success';
            case 'Partially Shipped':
                return 'success';
            case 'Cancelled':
                return 'warning';
            default:
                return 'new'
        }
    }


    const GetStatusBadge = (badge: string) => {
        return <Badge tone={getShopifyBadgeColor(badge)}>{badge ?? "N/A"}</Badge>

    }

    const [valueSearch, setvalueSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    const debounceSEarch = useDebounce(valueSearch, 1000)
    const debouncePage = useDebounce(currentPage, 1000)
    const [loading, setloading] = useState(false)


    useEffect(() => {
        setloading(true)
        let payload: any = {
            activePage: currentPage
        }
        if (valueSearch) {
            payload["order_id"] = valueSearch
        }

        props.di.POST("amazon/request/getArchiveOrders", payload).then((response) => {
            if (response.success) {
                let rows: any = [];
                response?.data?.map((obj: any) => {
                    let shopUrl = getShopifyShopUrl(obj?.targets?.[0]?.order_id, props);
                    rows.push(
                        {
                            key: obj['marketplace_reference_id'],
                            id: <BlockStack gap="200">
                                <InlineStack gap="200" blockAlign='center' wrap={false}>
                                    <AmazonIcon />
                                    <Link removeUnderline target='_blank' url={getAmazonOrderUrl(obj?.marketplace_reference_id, props)}>
                                        <InlineStack gap="100" wrap={false}>
                                            <Text as='span'>{obj?.marketplace_reference_id}</Text>
                                            <Icon source={ExternalSmallMinor} tone="base" />
                                        </InlineStack>
                                    </Link>
                                </InlineStack>
                                <InlineStack gap="200" blockAlign='center' wrap={false}>
                                    <ShopifyIcon />
                                    <Text as="span" tone='subdued'>
                                        {
                                            obj?.targets[0]?.order_id ?
                                                <Link removeUnderline target='_blank' url={shopUrl}>
                                                    <InlineStack gap="100" wrap={false}>
                                                        <Text as='span'>{obj?.targets[0]?.order_id}</Text>
                                                        <Icon source={ExternalSmallMinor} tone="base" />
                                                    </InlineStack>
                                                </Link> : "-"
                                        }
                                    </Text>
                                </InlineStack>
                            </BlockStack>,
                            type: <InlineStack gap={"200"}>
                                <Text as='p'>2024-12-01</Text>
                                <Text as='p'>{<Tooltip content={obj['archive_type'] == 'manual' ? "Manually archived order." : "Automatically archived order."} hasUnderline><Badge>{obj['archive_type']}</Badge></Tooltip>}</Text>
                            </InlineStack>,
                            tags: <Tag>{obj['fulfilled_by'] == 'merchant' ? "FBM" : "FBA"}</Tag>,
                            status: GetStatusBadge(obj?.targets[0]?.status ?? "N/A"),
                            creation_date: formatDate(obj?.order_created_at),
                            date: obj?.items?.attributes?.purchase_date ?? t('Not assigned yet'),
                            actions: (
                                <ButtonGroup variant="segmented">
                                    <Button onClick={() => props.history(`./newArchievedOrder`, { state: { id: obj?.marketplace_reference_id } })}>{t("View order")}</Button>
                                </ButtonGroup>
                            )
                        }
                    )
                })
                setTotalItems(Math.ceil(response?.['count'] / pageSize))
                setrows(rows)

            } else {
                props.error(response?.message ?? t("something went wrong"))
            }
            setloading(false)
        })
    }, [debounceSEarch, debouncePage])

    const columns = [
        {
            title: t('Order Id'),
            dataIndex: 'id',
            width: '400px',
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            width: '250px',
        },
        {
            title: t('Date/Type'),
            dataIndex: 'type',
            width: '360px',
        },
        {
            title: t('Creation Date'),
            dataIndex: 'creation_date',
            width: '250px',
        },
        {
            title: t('Tags'),
            dataIndex: 'tags',
            width: '250px',
        },
        {
            title: t('Actions'),
            dataIndex: 'actions',
            width: '250px',
        }
    ];

    const handleTableChange = (pagination: any) => {
        setCurrentPage(pagination.current);
        // if total changes from a server response, you can update setTotalItems here
    };

    const handlePreviousPagination = () => {

        setCurrentPage(prev => prev - 1);
    }
    const handleNextPagination = () => {

        setCurrentPage(prev => prev + 1);
    }



    return (
        <BlockStack gap={"200"}>
            <TextField autoComplete='off' value={valueSearch} onChange={val => { setCurrentPage(1); setvalueSearch(val) }} label labelHidden placeholder='Search using the Amazon order ID' />
            <Table
                columns={columns}
                dataSource={!loading ? rowsData : skeletonRow}
                scroll={{ x: 800 }}
                pagination={false}
                onChange={handleTableChange}
                size='middle'
            />
            <InlineStack align="center" gap="400" >
                <Pagination
                    label={`${currentPage}/${totalItems}`}
                    hasPrevious={currentPage > 1}
                    onPrevious={() => handlePreviousPagination()}
                    hasNext={currentPage < totalItems}
                    onNext={() => handleNextPagination()}
                />
            </InlineStack>
        </BlockStack>
    );
}

export default DI(NewArchievedOrderTable);